import fetch from 'auth/FetchInterceptor'
import {API_BASE_URL} from '../configs/AppConfig'
const SubscriptionService = {}


SubscriptionService.getAllPlan = function (params) {
	 
	 let offset = (params-1)*10;
	return fetch({
		url: API_BASE_URL+'/v1/admin/all-subscription-plan',
		method: 'get',
        params: {
            'offset' : offset
        }
	})
}; 


SubscriptionService.getUserSubscription = function (params) {
	 
	let offset = (params-1)*10;
   return fetch({
	   url: API_BASE_URL+'/v1/admin/user-subscription',
	   method: 'get',
	   params: {
		   'offset' : offset
	   }
   })
}; 

SubscriptionService.buySubscription = function (data) {
	 
   return fetch({
	   url: API_BASE_URL+'/v1/admin/buy-subscription-plan',
	   method: 'post',
	    data
	
   })
};

SubscriptionService.cancelSubscription = function (data) {
	 
	return fetch({
		url: API_BASE_URL+'/v1/admin/cancel-subscription-plan',
		method: 'post',
		 data
	 
	})
 }; 

 SubscriptionService.resumeSubscription = function (data) {
	 
	return fetch({
		url: API_BASE_URL+'/v1/admin/resume-subscription-plan',
		method: 'post',
		 data
	 
	})
 }; 



export default SubscriptionService;